/* eslint-disable no-confusing-arrow */
/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable indent */
/* eslint-disable quotes */
import React from "react";
import PropTypes from "prop-types";
import { omit, get, set, flowRight, size, isEmpty, noop } from "lodash";
import { injectIntl, FormattedMessage, FormattedDate } from "react-intl";
import saveAs from "file-saver";
import moment from "moment";
import classnames from "classnames";
import { stringify } from "query-string";

import {
  Pluggable,
  AppIcon,
  IfPermission,
  CalloutContext,
  stripesConnect,
  withNamespace,
  checkIfUserInCentralTenant,
  TitleManager,
} from "@folio/stripes/core";
import { SearchAndSort } from "@folio/stripes/smart-components";
import {
  Button,
  Icon,
  Checkbox,
  MenuSection,
  Select,
  HasCommand,
  MCLPagingTypes,
  TextLink,
  DefaultMCLRowFormatter,
} from "@folio/stripes/components";

import { withSingleRecordImport } from "..";
import FilterNavigation from "../FilterNavigation";
import SearchModeNavigation from "../SearchModeNavigation";
import ColumnSelectionModal from "./ColumnSelectionModal";
import packageInfo from "../../../package";
import InstanceForm from "../../edit/InstanceForm";
import ViewInstanceWrapper from "../../ViewInstanceWrapper";
import formatters from "../../referenceFormatters";
import withLocation from "../../withLocation";
import {
  getCurrentFilters,
  getNextSelectedRowsState,
  parseFiltersToStr,
  marshalInstance,
  omitFromArray,
  isTestEnv,
  handleKeyCommand,
  buildSingleItemQuery,
  isUserInConsortiumMode,
  switchAffiliation,
  addFilter,
  replaceFilter,
} from "../../utils";
import {
  INSTANCES_ID_REPORT_TIMEOUT,
  SORTABLE_SEARCH_RESULT_LIST_COLUMNS,
  queryIndexes,
  segments,
  OKAPI_TENANT_HEADER,
  CONTENT_TYPE_HEADER,
  OKAPI_TOKEN_HEADER,
  FACETS,
  USER_TOUCHED_STAFF_SUPPRESS_STORAGE_KEY,
} from "../../constants";
import { IdReportGenerator, InTransitItemsReport } from "../../reports";
import ErrorModal from "../ErrorModal";
import CheckboxColumn from "./CheckboxColumn";
import SelectedRecordsModal from "../SelectedRecordsModal";
import ImportRecordModal from "../ImportRecordModal";
import { buildQuery } from "../../routes/buildManifestObject";
import { getItem, setItem } from "../../storage";
import facetsStore from "../../stores/facetsStore";
import { advancedSearchIndexes } from "../../filterConfig";

import css from "./instances.css";

const INITIAL_RESULT_COUNT = 30;
const RESULT_COUNT_INCREMENT = 30;

const TOGGLEABLE_COLUMNS = [
  "contributors",
  "publishers",
  "publication date",
  "subjects",
  "languages",
  "classification",
  "createdDate",
  "updatedDate",
  "hrid",
  "instanceType",
  "series",
  "editions",
  "identifiers",
  "instanceStatus",
  "source",
  "catalogedDate",
  "modeOfIssuance",
  "physicalDescriptions",
  "notes",
  "alternativeTitles",
  "indexTitle",
  "natureOfContent",
  "statisticalCodes",
];
const NON_TOGGLEABLE_COLUMNS = ["select", "title"];
const ALL_COLUMNS = Array.from(
  new Set([...NON_TOGGLEABLE_COLUMNS, ...TOGGLEABLE_COLUMNS]),
);
const VISIBLE_COLUMNS_STORAGE_KEY = "inventory-visible-columns";

class InstancesList extends React.Component {
  static defaultProps = {
    canUseSingleRecordImport: false,
    showSingleResult: true,
    segment: segments.instances,
  };

  static propTypes = {
    canUseSingleRecordImport: PropTypes.bool,
    data: PropTypes.object,
    parentResources: PropTypes.object,
    parentMutator: PropTypes.object,
    showSingleResult: PropTypes.bool,
    disableRecordCreation: PropTypes.bool,
    updateLocation: PropTypes.func.isRequired,
    goTo: PropTypes.func.isRequired,
    getParams: PropTypes.func.isRequired,
    segment: PropTypes.string,
    intl: PropTypes.object,
    match: PropTypes.shape({
      path: PropTypes.string.isRequired,
      params: PropTypes.object.isRequired,
    }).isRequired,
    namespace: PropTypes.string,
    renderFilters: PropTypes.func.isRequired,
    searchableIndexes: PropTypes.arrayOf(PropTypes.object).isRequired,
    mutator: PropTypes.shape({
      query: PropTypes.shape({
        update: PropTypes.func.isRequired,
        replace: PropTypes.func.isRequired,
      }).isRequired,
    }),
    location: PropTypes.shape({
      search: PropTypes.string,
      state: PropTypes.object,
      pathname: PropTypes.string,
    }),
    stripes: PropTypes.object.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func,
      listen: PropTypes.func,
      replace: PropTypes.func,
    }),
    getLastBrowse: PropTypes.func.isRequired,
    getLastSearchOffset: PropTypes.func.isRequired,
    storeLastSearch: PropTypes.func.isRequired,
    storeLastSearchOffset: PropTypes.func.isRequired,
    storeLastSegment: PropTypes.func.isRequired,
  };

  static contextType = CalloutContext;

  static manifest = Object.freeze({
    query: {},
  });

  constructor(props) {
    super(props);

    this.paneTitleRef = React.createRef();

    this.state = {
      showNewFastAddModal: false,
      inTransitItemsExportInProgress: false,
      instancesIdExportInProgress: false,
      holdingsIdExportInProgress: false,
      instancesQuickExportInProgress: false,
      showErrorModal: false,
      selectedRows: {},
      isSelectedRecordsModalOpened: false,
      visibleColumns: this.getInitialToggableColumns(),
      isImportRecordModalOpened: false,
      searchAndSortKey: 0,
      segmentsSortBy: this.getInitialSegmentsSortBy(),
      isSingleResult: this.props.showSingleResult,
      searchInProgress: false,
      isColumnModalOpen: false,
    };
  }

  componentDidMount() {
    const { history, getParams } = this.props;

    const params = getParams();

    this.unlisten = history.listen((location) => {
      const hasReset = new URLSearchParams(location.search).get("reset");

      if (hasReset) {
        // imperative way is used because it's no option in SearchAndSort reset/focus filters from outside
        document.getElementById("clickable-reset-all")?.click();
        this.inputRef.current.focus();

        history.replace({ search: "segment=instances" });
      }
    });

    window.addEventListener("beforeunload", this.handleBeforeUnload);

    if (params.selectedBrowseResult === "true") {
      this.paneTitleRef.current.focus();
    }

    this.processLastSearchTerms();

    this.applyDefaultStaffSuppressFilter();
  }

  componentDidUpdate(prevProps) {
    const sortBy = this.getSortFromParams();

    this.storeLastSearchTerms(prevProps);

    if (
      this.state.segmentsSortBy.find(
        (x) => x.name === this.props.segment && x.sort !== sortBy,
      )
    ) {
      this.setSegmentSortBy(sortBy);
    }

    const prevId = this.getInstanceIdFromLocation(prevProps.location);
    const id = this.getInstanceIdFromLocation(this.props.location);

    if (id) {
      setItem(
        `${this.props.namespace}.${this.props.segment}.lastOpenRecord`,
        id,
      );
    } else if (prevId) {
      setItem(
        `${this.props.namespace}.${this.props.segment}.lastOpenRecord`,
        null,
      );
    }

    if (prevProps.segment !== this.props.segment) {
      this.applyDefaultStaffSuppressFilter();
    }
  }

  componentWillUnmount() {
    const { parentMutator } = this.props;

    this.unlisten();
    parentMutator.records.reset();
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  }

  inputRef = React.createRef();
  indexRef = React.createRef();

  extraParamsToReset = {
    selectedBrowseResult: false,
    authorityId: "",
  };

  handleBeforeUnload = () => {
    sessionStorage.setItem(USER_TOUCHED_STAFF_SUPPRESS_STORAGE_KEY, false);
  };

  redirectToSearchParams = (searchParams) => {
    const { history, location } = this.props;

    history.replace({
      pathname: location.pathname,
      search: searchParams.toString(),
      state: location.state,
    });
  };

  applyDefaultStaffSuppressFilter = () => {
    const { location } = this.props;

    if (
      JSON.parse(
        sessionStorage.getItem(USER_TOUCHED_STAFF_SUPPRESS_STORAGE_KEY),
      )
    ) {
      return;
    }

    const searchParams = new URLSearchParams(location.search);
    const filters = searchParams.get("filters");

    const staffSuppressFalse = `${FACETS.STAFF_SUPPRESS}.false`;
    const staffSuppressTrue = `${FACETS.STAFF_SUPPRESS}.true`;

    if (!filters?.includes(FACETS.STAFF_SUPPRESS)) {
      const newFiltersValue = addFilter(filters, staffSuppressFalse);

      searchParams.set("filters", newFiltersValue);
      this.redirectToSearchParams(searchParams);

      return;
    }

    const isStaffSuppressFilterAvailable = this.props.stripes.hasPerm(
      "ui-inventory.instance.view-staff-suppressed-records",
    );
    const isStaffSuppressTrueSelected = filters.includes(
      `${FACETS.STAFF_SUPPRESS}.true`,
    );

    if (!isStaffSuppressFilterAvailable && isStaffSuppressTrueSelected) {
      const newFiltersValue = replaceFilter(
        filters,
        staffSuppressTrue,
        staffSuppressFalse,
      );

      searchParams.set("filters", newFiltersValue);
      this.redirectToSearchParams(searchParams);
    }
  };

  getInstanceIdFromLocation = (location) => {
    return location.pathname.split("/")[3];
  };

  getPageTitle = () => {
    const {
      data: { query },
      intl,
    } = this.props;

    if (!query.query) {
      return intl.formatMessage({ id: "ui-inventory.meta.title" });
    }

    return intl.formatMessage(
      { id: "ui-inventory.documentTitle.search" },
      { query: query.query },
    );
  };

  processLastSearchTerms = () => {
    const {
      getParams,
      location,
      parentMutator,
      getLastSearchOffset,
      storeLastSearch,
      segment,
    } = this.props;
    const params = getParams();
    const lastSearchOffset = getLastSearchOffset(segment);
    const offset =
      params.selectedBrowseResult === "true" ? 0 : lastSearchOffset;

    storeLastSearch(location.search, segment);
    parentMutator.resultOffset.replace(offset);
  };

  storeLastSearchTerms = (prevProps) => {
    const {
      location,
      parentResources,
      storeLastSearch,
      storeLastSearchOffset,
      segment,
    } = this.props;

    if (prevProps.location.search !== location.search) {
      storeLastSearch(location.search, segment);
    }

    if (
      prevProps.parentResources.resultOffset !== parentResources.resultOffset
    ) {
      storeLastSearchOffset(parentResources.resultOffset, segment);
    }
  };

  getSortFromParams = () => {
    const params = new URLSearchParams(this.props.location.search);
    return params.get("sort");
  };

  getInitialToggableColumns = () => {
    return getItem(VISIBLE_COLUMNS_STORAGE_KEY) || [
      "contributors",
      "publication date",
      "publishers",
      "subjects",
      "languages",
      "classification",
      "createdDate",
      "updatedDate",
    ];
  };

  getInitialSegmentsSortBy = () => {
    return Object.keys(segments).map((name) => ({
      name,
      sort: SORTABLE_SEARCH_RESULT_LIST_COLUMNS.TITLE,
    }));
  };

  getVisibleColumns = () => {
    const columns = this.state.visibleColumns;
    const visibleColumns = new Set([...columns, ...NON_TOGGLEABLE_COLUMNS]);

    return ALL_COLUMNS.filter((key) => visibleColumns.has(key));
  };

  onFilterChangeHandler = ({ name, values }) => {
    const {
      data: { query },
      match: { path },
      goTo,
      getParams,
    } = this.props;

    const curFilters = getCurrentFilters(get(query, "filters", ""));
    const mergedFilters = values.length
      ? { ...curFilters, [name]: values }
      : omit(curFilters, name);
    const filtersStr = parseFiltersToStr(mergedFilters);
    const params = getParams();

    goTo(path, { ...params, filters: filtersStr });
  };

  onSubmitSearch = () => {
    this.setState({
      searchInProgress: true,
    });
  };

  closeNewInstance = (e) => {
    if (e) e.preventDefault();
    this.setState({ copiedInstance: null });
    this.props.updateLocation({ layer: null });
  };

  createInstance = (instanceData) => {
    const {
      data: { identifierTypesByName },
    } = this.props;

    // Massage record to add preceeding and succeeding title fields
    const instance = marshalInstance(instanceData, identifierTypesByName);

    // POST item record
    return this.props.parentMutator.records.POST(instance);
  };

  onCreate = (instance) => {
    return this.createInstance(instance).then(() => this.closeNewInstance());
  };

  openCreateInstance = () => {
    this.props.updateLocation({ layer: "create" });
  };

  openCreateMARCRecord = () => {
    const searchParams = new URLSearchParams(this.props.location.search);
    this.props.goTo(`/inventory/quick-marc/create-bib?${searchParams}`);
  };

  /** kware start edit -- Adding create new instance wizard route */
  openNewInstanceModal = () => {
    this.props.goTo("/inventory/instance-wizard");
  };

  /* kware start edit - Add handler for bulk edit instances */
  handleBulkEditInstances = async () => {
    const selectedIds = Object.keys(this.state.selectedRows);

    // Case 1: If there are selected instances
    if (selectedIds.length > 0) {
      sessionStorage.setItem(
        "bulkEditInstanceIds",
        JSON.stringify(selectedIds),
      );
      this.props.goTo("/inventory/bulk-edit-instances");
      return;
    }

    // Case 2: If no selection - fetch all IDs
    try {
      const { reset, GET } = this.props.parentMutator.recordsToExportIDs;
      reset();
      const items = await GET();

      if (!isEmpty(items)) {
        const allIds = items.map((record) => record.id);
        sessionStorage.setItem("bulkEditInstanceIds", JSON.stringify(allIds));
        this.props.goTo("/inventory/bulk-edit-instances");
      }
    } catch (error) {
      this.context.sendCallout({
        type: "error",
        message: <FormattedMessage id="ui-inventory.bulkEdit.fetchIdsError" />,
      });
    }
  };
  /* kware end edit */
  /** kware end edit */

  /* kware start edit - Add handler for bulk safe delete instances
   * This handler manages routing to the bulk safe delete plugin
   * It determines the best data passing method based on the number of selected instances
   */
  handleSafeDeleteMultiple = () => {
    const selectedIds = Object.keys(this.state.selectedRows);

    if (selectedIds.length === 0) {
      return;
    }

    // Choose data passing method based on count
    if (selectedIds.length <= 50) {
      // Use URL parameters for small numbers (under URL length limit)
      const idsParam = selectedIds.join(",");
      this.props.goTo(`/inventory/safe-delete-instance/bulk?ids=${idsParam}`);
    } else {
      // Use session storage for larger numbers
      sessionStorage.setItem("bulkInstanceIds", JSON.stringify(selectedIds));
      this.props.goTo("/inventory/safe-delete-instance/bulk");
    }
  };
  /* kware end edit */

  copyInstance = (instance) => {
    const {
      precedingTitles,
      succeedingTitles,
      childInstances,
      parentInstances,
    } = instance;
    let copiedInstance = omit(instance, ["id", "hrid"]);

    if (precedingTitles?.length) {
      copiedInstance.precedingTitles = omitFromArray(precedingTitles, "id");
    }

    if (succeedingTitles?.length) {
      copiedInstance.succeedingTitles = omitFromArray(succeedingTitles, "id");
    }

    if (childInstances?.length) {
      copiedInstance.childInstances = omitFromArray(childInstances, "id");
    }

    if (parentInstances?.length) {
      copiedInstance.parentInstances = omitFromArray(parentInstances, "id");
    }

    copiedInstance = set(copiedInstance, "source", "FOLIO");

    this.setState({ copiedInstance });
    this.openCreateInstance();
  };

  refocusOnInputSearch = (segment) => {
    const { storeLastSegment } = this.props;

    // when navigation button is clicked to change the search segment
    // the focus stays on the button so refocus back on the input search.
    // https://issues.folio.org/browse/UIIN-1358
    storeLastSegment(segment);
    facetsStore.getState().resetFacetSettings();
    this.inputRef.current.focus();
  };

  handleSearchSegmentChange = (segment) => {
    this.refocusOnInputSearch(segment);
    this.setState({ selectedRows: {} });
    sessionStorage.setItem(USER_TOUCHED_STAFF_SUPPRESS_STORAGE_KEY, false);
  };

  onSearchModeSwitch = () => {
    const {
      namespace,
      location: { pathname },
      segment,
    } = this.props;

    const id = pathname.split("/")[3];

    if (id) {
      setItem(`${namespace}.${segment}.lastOpenRecord`, id);
    }
  };

  renderNavigation = () => (
    <>
      <SearchModeNavigation
        search={this.props.getLastBrowse()}
        onSearchModeSwitch={this.onSearchModeSwitch}
      />
      <FilterNavigation
        segment={this.props.segment}
        onChange={this.handleSearchSegmentChange}
      />
    </>
  );

  generateInTransitItemReport = async () => {
    const {
      intl: { formatMessage },
      parentMutator,
    } = this.props;
    const { sendCallout, removeCallout } = this.context;
    const calloutId = sendCallout({
      message: <FormattedMessage id="ui-inventory.exportInProgress" />,
      timeout: 0,
    });

    try {
      const report = new InTransitItemsReport(parentMutator, formatMessage);
      const items = await report.toCSV();

      if (!items?.length) {
        this.setState({ showErrorModal: true });
      }
    } catch (error) {
      throw new Error(error);
    } finally {
      removeCallout(calloutId);
      this.setState({ inTransitItemsExportInProgress: false });
    }
  };

  startInTransitReportGeneration = () => {
    const { inTransitItemsExportInProgress } = this.state;

    if (inTransitItemsExportInProgress) {
      return;
    }

    this.setState(
      { inTransitItemsExportInProgress: true },
      this.generateInTransitItemReport,
    );
  };

  generateInstancesIdReport = async (sendCallout) => {
    const { instancesIdExportInProgress } = this.state;

    if (instancesIdExportInProgress) return;

    this.setState({ instancesIdExportInProgress: true }, async () => {
      const { reset, GET } = this.props.parentMutator.recordsToExportIDs;
      let infoCalloutTimer;

      try {
        reset();

        infoCalloutTimer = setTimeout(() => {
          sendCallout({
            type: "info",
            message: (
              <FormattedMessage id="ui-inventory.saveInstancesUIIDS.info" />
            ),
          });
        }, INSTANCES_ID_REPORT_TIMEOUT);

        const items = await GET();

        clearTimeout(infoCalloutTimer);

        const report = new IdReportGenerator("SearchInstanceUUIDs");

        if (!isEmpty(items)) {
          report.toCSV(items, (record) => record.id);
        }
      } catch (error) {
        clearTimeout(infoCalloutTimer);

        sendCallout({
          type: "error",
          message: (
            <FormattedMessage id="ui-inventory.saveInstancesUIIDS.error" />
          ),
        });
      } finally {
        this.setState({ instancesIdExportInProgress: false });
      }
    });
  };

  triggerQuickExport = async (sendCallout) => {
    const { instancesQuickExportInProgress } = this.state;

    if (instancesQuickExportInProgress) return;

    this.setState({ instancesQuickExportInProgress: true });

    try {
      const instanceIds = Object.keys(this.state.selectedRows);

      await this.props.parentMutator.quickExport.POST({
        uuids: instanceIds,
        type: "uuid",
        recordType: "INSTANCE",
      });
      new IdReportGenerator("QuickInstanceExport").toCSV(instanceIds);
    } catch (error) {
      sendCallout({
        type: "error",
        message: <FormattedMessage id="ui-inventory.communicationProblem" />,
      });
    } finally {
      this.setState({ instancesQuickExportInProgress: false });
    }
  };

  generateCQLQueryReport = async () => {
    if (!isTestEnv()) {
      const { data } = this.props;

      const query = buildQuery(data.query, {}, data, { log: noop }, this.props);
      const fileName = `SearchInstanceCQLQuery${moment().format()}.cql`;

      saveAs(
        new Blob([query], { type: "text/plain;charset=utf-8;" }),
        fileName,
      );
    }
  };

  toggleNewFastAddModal = () => {
    this.setState((state) => {
      return { showNewFastAddModal: !state.showNewFastAddModal };
    });
  };

  handleFastAddModalClose = ({ instanceRecord } = {}) => {
    const { history, location } = this.props;

    if (instanceRecord?.id) {
      history.push({
        pathname: `/inventory/view/${instanceRecord.id}`,
        search: location.search,
      });
    }

    this.toggleNewFastAddModal();
  };

  generateHoldingsIdReport = async (sendCallout) => {
    const { holdingsIdExportInProgress } = this.state;

    if (holdingsIdExportInProgress) return;

    this.setState({ holdingsIdExportInProgress: true }, async () => {
      const { reset, GET } = this.props.parentMutator.holdingsToExportIDs;
      let infoCalloutTimer;

      try {
        reset();

        infoCalloutTimer = setTimeout(() => {
          sendCallout({
            type: "info",
            message: (
              <FormattedMessage id="ui-inventory.saveHoldingsUIIDS.info" />
            ),
          });
        }, INSTANCES_ID_REPORT_TIMEOUT);

        const items = await GET();

        clearTimeout(infoCalloutTimer);

        const report = new IdReportGenerator("SearchHoldingsUUIDs");

        if (!isEmpty(items)) {
          report.toCSV(items, (record) => record.id);
        }
      } catch (error) {
        clearTimeout(infoCalloutTimer);

        sendCallout({
          type: "error",
          message: (
            <FormattedMessage id="ui-inventory.saveHoldingsUIIDS.error" />
          ),
        });
      } finally {
        this.setState({ instancesIdExportInProgress: false });
      }
    });
  };

  handleExcelExport = async (selectedColumns, customReportName) => {
    const { intl, parentResources, parentMutator, data } = this.props;
    const { sendCallout } = this.context;
    
    const instancesCount = get(parentResources, ['records', 'other', 'totalRecords'], 0);
    const currentInstances = get(parentResources, ['records', 'records'], []);
    
    if (instancesCount === 0) {
      sendCallout({
        message: intl.formatMessage({ id: 'ui-inventory.excel.export.error' }),
        type: 'error',
      });
      return;
    }

    if (instancesCount > 5000) {
      sendCallout({
        message: intl.formatMessage({ id: 'ui-inventory.excel.export.limitExceeded' }, { max: 5000 }),
        type: 'error',
      });
      return;
    }

    let allInstances = currentInstances;

    if (instancesCount > currentInstances.length) {
      sendCallout({
        message: intl.formatMessage({ id: 'ui-inventory.excel.export.loading' }, { total: instancesCount }),
        type: 'info',
      });

      try {
        const BATCH_SIZE = 100;
        allInstances = [];
        let offset = 0;

        const query = buildQuery(data.query, {}, data, { log: noop }, this.props);

        while (offset < instancesCount) {
          const response = await parentMutator.records.GET({
            params: {
              limit: BATCH_SIZE,
              offset,
              query,
              expandAll: true,
            },
          });

          const batch = response?.instances || response || [];

          if (!batch || batch.length === 0) break;
          
          allInstances.push(...batch);
          offset += BATCH_SIZE;

          if (batch.length < BATCH_SIZE) break;
        }

        sendCallout({
          message: intl.formatMessage({ id: 'ui-inventory.excel.export.dataLoaded' }, { total: allInstances.length }),
          type: 'success',
        });
      } catch (error) {
        console.error('Error loading all instances:', error);
        sendCallout({
          message: intl.formatMessage({ id: 'ui-inventory.excel.export.error' }),
          type: 'error',
        });
        return;
      }
    }

    try {
      const { exportToExcel } = await import('../../helpers/excelExport');
      
      const translations = {
        platformTitle: intl.formatMessage({ id: 'ui-inventory.excel.platformTitle' }),
        moduleTitle: intl.formatMessage({ id: 'ui-inventory.excel.moduleTitle' }),
        generatedDate: intl.formatMessage({ id: 'ui-inventory.excel.generatedDate' }),
        generatedTime: intl.formatMessage({ id: 'ui-inventory.excel.generatedTime' }),
        totalRecords: intl.formatMessage({ id: 'ui-inventory.excel.totalRecords' }),
        reportType: intl.formatMessage({ id: 'ui-inventory.excel.reportType' }),
        reportTypeValue: intl.formatMessage({ id: 'ui-inventory.excel.reportTypeValue' }),
        systemVersion: intl.formatMessage({ id: 'ui-inventory.excel.systemVersion' }),
        generatedBy: intl.formatMessage({ id: 'ui-inventory.excel.generatedBy' }),
        generatedByValue: intl.formatMessage({ id: 'ui-inventory.excel.generatedByValue' }),
        disclaimer: intl.formatMessage({ id: 'ui-inventory.excel.disclaimer' }),
        copyright: intl.formatMessage({ id: 'ui-inventory.excel.copyright' }),
      };

      const columnMapping = {
        title: intl.formatMessage({ id: 'ui-inventory.instances.columns.title' }),
        contributors: intl.formatMessage({ id: 'ui-inventory.instances.columns.contributors' }),
        publishers: intl.formatMessage({ id: 'ui-inventory.instances.columns.publishers' }),
        'publication date': intl.formatMessage({ id: 'ui-inventory.instances.columns.publicationDate' }),
        classification: intl.formatMessage({ id: 'ui-inventory.instances.columns.classification' }),
        updatedDate: intl.formatMessage({ id: 'ui-inventory.instances.columns.updatedDate' }),
        hrid: intl.formatMessage({ id: 'ui-inventory.instances.columns.hrid' }),
        instanceType: intl.formatMessage({ id: 'ui-inventory.instances.columns.instanceType' }),
        languages: intl.formatMessage({ id: 'ui-inventory.instances.columns.languages' }),
        subjects: intl.formatMessage({ id: 'ui-inventory.instances.columns.subjects' }),
        series: intl.formatMessage({ id: 'ui-inventory.instances.columns.series' }),
        editions: intl.formatMessage({ id: 'ui-inventory.instances.columns.editions' }),
        identifiers: intl.formatMessage({ id: 'ui-inventory.instances.columns.identifiers' }),
        instanceStatus: intl.formatMessage({ id: 'ui-inventory.instances.columns.instanceStatus' }),
        source: intl.formatMessage({ id: 'ui-inventory.instances.columns.source' }),
        catalogedDate: intl.formatMessage({ id: 'ui-inventory.instances.columns.catalogedDate' }),
        modeOfIssuance: intl.formatMessage({ id: 'ui-inventory.instances.columns.modeOfIssuance' }),
        physicalDescriptions: intl.formatMessage({ id: 'ui-inventory.instances.columns.physicalDescriptions' }),
        notes: intl.formatMessage({ id: 'ui-inventory.instances.columns.notes' }),
        alternativeTitles: intl.formatMessage({ id: 'ui-inventory.instances.columns.alternativeTitles' }),
        indexTitle: intl.formatMessage({ id: 'ui-inventory.instances.columns.indexTitle' }),
        natureOfContent: intl.formatMessage({ id: 'ui-inventory.instances.columns.natureOfContent' }),
        statisticalCodes: intl.formatMessage({ id: 'ui-inventory.instances.columns.statisticalCodes' }),
        createdDate: intl.formatMessage({ id: 'ui-inventory.instances.columns.createdDate' }),
      };

      const processedData = allInstances.map(instance => {
        const processed = {};
        
        selectedColumns.forEach(col => {
          if (col === 'title') {
            processed[col] = instance.title || '';
          } else if (col === 'contributors') {
            processed[col] = formatters.contributorsFormatter(instance, data.contributorTypes);
          } else if (col === 'publishers') {
            processed[col] = (instance?.publication ?? [])
              .map(p => p ? `${p.publisher || ''} ${p.dateOfPublication ? `(${p.dateOfPublication})` : ''}` : '')
              .join(', ');
          } else if (col === 'publication date') {
            processed[col] = (instance.publication || []).map(p => p.dateOfPublication).join(', ');
          } else if (col === 'classification') {
            processed[col] = (instance?.classifications ?? [])
              .map(c => c.classificationNumber)
              .filter(Boolean)
              .join(', ');
          } else if (col === 'updatedDate') {
            processed[col] = instance.metadata?.updatedDate 
              ? new Date(instance.metadata.updatedDate).toLocaleString() 
              : '';
          } else if (col === 'hrid') {
            processed[col] = instance.hrid || '';
          } else if (col === 'instanceType') {
            const type = data.instanceTypes?.find(t => t.id === instance.instanceTypeId);
            processed[col] = type?.name || '';
          } else if (col === 'languages') {
            processed[col] = (instance.languages || []).join(', ');
          } else if (col === 'subjects') {
            processed[col] = (instance.subjects || []).map(s => typeof s === 'string' ? s : s.value).filter(Boolean).join(', ');
          } else if (col === 'series') {
            processed[col] = (instance.series || []).map(s => s.value).filter(Boolean).join(', ');
          } else if (col === 'editions') {
            processed[col] = (instance.editions || []).join(', ');
          } else if (col === 'identifiers') {
            processed[col] = (instance.identifiers || []).map(i => `${i.value}`).filter(Boolean).join(', ');
          } else if (col === 'instanceStatus') {
            const status = data.instanceStatuses?.find(s => s.id === instance.statusId);
            processed[col] = status?.name || '';
          } else if (col === 'source') {
            processed[col] = instance.source || '';
          } else if (col === 'catalogedDate') {
            processed[col] = instance.catalogedDate ? new Date(instance.catalogedDate).toLocaleDateString() : '';
          } else if (col === 'modeOfIssuance') {
            const mode = data.modesOfIssuance?.find(m => m.id === instance.modeOfIssuanceId);
            processed[col] = mode?.name || '';
          } else if (col === 'physicalDescriptions') {
            processed[col] = (instance.physicalDescriptions || []).join(', ');
          } else if (col === 'notes') {
            processed[col] = (instance.notes || []).map(n => n.note).filter(Boolean).join('; ');
          } else if (col === 'alternativeTitles') {
            processed[col] = (instance.alternativeTitles || []).map(t => t.alternativeTitle).filter(Boolean).join(', ');
          } else if (col === 'indexTitle') {
            processed[col] = instance.indexTitle || '';
          } else if (col === 'natureOfContent') {
            processed[col] = (instance.natureOfContentTermIds || []).map(id => {
              const term = data.natureOfContentTerms?.find(t => t.id === id);
              return term?.name || '';
            }).filter(Boolean).join(', ');
          } else if (col === 'statisticalCodes') {
            processed[col] = (instance.statisticalCodeIds || []).map(id => {
              const code = data.statisticalCodes?.find(c => c.id === id);
              return code?.code || '';
            }).filter(Boolean).join(', ');
          } else if (col === 'createdDate') {
            processed[col] = instance.metadata?.createdDate ? new Date(instance.metadata.createdDate).toLocaleDateString() : '';
          } else {
            processed[col] = instance[col] || '';
          }
        });
        
        return processed;
      });

      const result = await exportToExcel(processedData, customReportName, translations, selectedColumns, columnMapping);

      if (result.success) {
        sendCallout({
          message: intl.formatMessage({ id: 'ui-inventory.excel.export.success' }),
          type: 'success',
        });
      } else {
        sendCallout({
          message: intl.formatMessage({ id: 'ui-inventory.excel.export.error' }),
          type: 'error',
        });
      }
    } catch (error) {
      console.error('Excel export error:', error);
      sendCallout({
        message: intl.formatMessage({ id: 'ui-inventory.excel.export.error' }),
        type: 'error',
      });
    }
  };

  getActionItem = ({
    id,
    icon,
    messageId,
    onClickHandler,
    isDisabled = false,
  }) => {
    return (
      <Button
        buttonStyle="dropdownItem"
        id={id}
        disabled={isDisabled}
        onClick={onClickHandler}
      >
        <Icon icon={icon} size="medium" iconClassName={css.actionIcon} />
        <FormattedMessage id={messageId} />
      </Button>
    );
  };

  handleToggleColumn = ({ target: { value: key } }) => {
    this.setState(
      ({ visibleColumns }) => ({
        visibleColumns: visibleColumns.includes(key)
          ? visibleColumns.filter((k) => key !== k)
          : [...visibleColumns, key],
      }),
      () => {
        setItem(VISIBLE_COLUMNS_STORAGE_KEY, this.state.visibleColumns);
      },
    );
  };

  onMarkPosition = (position) => {
    const { namespace } = this.props;
    setItem(`${namespace}.position`, position);
  };

  resetMarkedPosition = () => {
    const { namespace } = this.props;
    setItem(`${namespace}.position`, null);
  };

  setSegmentSortBy = (sortBy) => {
    const { segment } = this.props;

    this.setState((prevState) => ({
      segmentsSortBy: prevState.segmentsSortBy.map((key) => {
        if (key.name === segment) {
          key.sort = sortBy;
          return key;
        }
        return key;
      }),
    }));
  };

  getActionMenu = ({ onToggle }) => {
    const {
      canUseSingleRecordImport,
      parentResources,
      intl,
      segment,
      stripes,
    } = this.props;
    const { inTransitItemsExportInProgress } = this.state;
    const selectedRowsCount = size(this.state.selectedRows);
    const isInstancesListEmpty = isEmpty(
      get(parentResources, ["records", "records"], []),
    );
    const visibleColumns = this.getVisibleColumns();
    const columnMapping = this.getColumnMapping();
    const canExportMarc = stripes.hasPerm("ui-data-export.app.enabled");
    const canCreateItemsInTransitReport = stripes.hasPerm(
      "ui-inventory.items.create-in-transit-report",
    );
    /* kware start edit - Add permission check for bulk safe delete functionality */
    const canSafeDeleteMultiple =
      stripes.hasPerm(
        "ui-inventory.instance.set-deletion-and-staff-suppress",
      ) && !checkIfUserInCentralTenant(stripes);
    /* kware end edit */

    const buildOnClickHandler = (onClickHandler) => {
      return () => {
        onToggle();

        onClickHandler(this.context.sendCallout);
      };
    };

    const setSortedColumn = (event) => {
      const {
        match: { path },
        goTo,
        getParams,
      } = this.props;

      onToggle();

      const params = getParams();
      params.sort = event.target.value;

      this.setSegmentSortBy(params.sort);

      const { sort, ...rest } = params;
      const queryParams = params.sort === "" ? rest : { sort, ...rest };

      goTo(path, { ...queryParams });
    };

    const sortOptions = Object.values(SORTABLE_SEARCH_RESULT_LIST_COLUMNS).map(
      (option) => ({
        value: option,
        label: intl.formatMessage({
          id: `ui-inventory.actions.menuSection.sortBy.${option}`,
        }),
      }),
    );

    const getSortByValue = () => {
      return (
        this.state.segmentsSortBy
          .find((x) => x.name === segment)
          .sort?.replace("-", "") || ""
      );
    };

    return (
      <>
        <MenuSection
          label={intl.formatMessage({ id: "ui-inventory.actions" })}
          id="actions-menu-section"
        >
          {/* <IfPermission perm="ui-inventory.instance.create">
            {this.getActionItem({
              id: "clickable-newinventory",
              icon: checkIfUserInCentralTenant(stripes) ? "graph" : "plus-sign",
              messageId: !isUserInConsortiumMode(stripes)
                ? "stripes-smart-components.new"
                : checkIfUserInCentralTenant(stripes)
                ? "ui-inventory.newSharedRecord"
                : "ui-inventory.newLocalRecord",
              onClickHandler: buildOnClickHandler(this.openCreateInstance),
            })}
          </IfPermission> */}
          {/** kware start edit section -- Adding create new instance route from inventory templates plugin */}
          <IfPermission perm="ui-plugin-inventory-templates.inventoryTemplates.view">
            <Button
              buttonStyle="dropdownItem"
              id="clickable-add-new-instance"
              onClick={buildOnClickHandler(this.openNewInstanceModal)}
            >
              <Icon
                icon="plus-sign"
                size="medium"
                iconClassName={css.actionIcon}
              />
              <FormattedMessage
                id="ui-plugin-inventory-templates.chooseTemplateType.modal.label"
                defaultMessage="Add new instance"
              />
            </Button>
          </IfPermission>
          {/** kware end edit section */}
          {!checkIfUserInCentralTenant(stripes) && (
            <Pluggable
              id="clickable-create-inventory-records"
              onClose={this.handleFastAddModalClose}
              renderInPaneset={false}
              open={this.state.showNewFastAddModal} // control the open modal via state var
              renderTrigger={() =>
                this.getActionItem({
                  id: "new-fast-add-record",
                  icon: "lightning",
                  messageId: "ui-inventory.newFastAddRecord",
                  onClickHandler: buildOnClickHandler(
                    this.toggleNewFastAddModal,
                  ),
                })
              }
              type="create-inventory-records"
            />
          )}
          {/* <IfPermission perm="ui-quick-marc.quick-marc-editor.create">
            <Button
              buttonStyle="dropdownItem"
              id="clickable-newmarcrecord"
              onClick={buildOnClickHandler(this.openCreateMARCRecord)}
            >
              <Icon
                icon="plus-sign"
                size="medium"
                iconClassName={css.actionIcon}
              />
              <FormattedMessage id="ui-inventory.newMARCRecord" />
            </Button>
          </IfPermission> */}

          {inTransitItemsExportInProgress
            ? this.getActionItem({
                id: "dropdown-clickable-get-report",
                icon: "report",
                messageId: "ui-inventory.exportInProgress",
              })
            : canCreateItemsInTransitReport &&
              !checkIfUserInCentralTenant(stripes) &&
              this.getActionItem({
                id: "dropdown-clickable-get-report",
                icon: "report",
                messageId: "ui-inventory.inTransitReport",
                onClickHandler: buildOnClickHandler(
                  this.startInTransitReportGeneration,
                ),
              })}
          {this.getActionItem({
            id: "dropdown-clickable-get-instances-uiids",
            icon: "save",
            messageId: "ui-inventory.saveInstancesUIIDS",
            onClickHandler: buildOnClickHandler(this.generateInstancesIdReport),
            isDisabled: isInstancesListEmpty,
          })}
          {segment === "holdings" &&
            this.getActionItem({
              id: "dropdown-clickable-get-holdings-uiids",
              icon: "save",
              messageId: "ui-inventory.saveHoldingsUIIDS",
              onClickHandler: buildOnClickHandler(
                this.generateHoldingsIdReport,
              ),
              isDisabled: isInstancesListEmpty,
            })}
          {this.getActionItem({
            id: "dropdown-clickable-get-cql-query",
            icon: "search",
            messageId: "ui-inventory.saveInstancesCQLQuery",
            onClickHandler: buildOnClickHandler(this.generateCQLQueryReport),
            isDisabled: isInstancesListEmpty,
          })}
          {canExportMarc &&
            this.getActionItem({
              id: "dropdown-clickable-export-marc",
              icon: "download",
              messageId: "ui-inventory.exportInstancesInMARC",
              onClickHandler: buildOnClickHandler(this.triggerQuickExport),
              isDisabled: !selectedRowsCount,
            })}
          {this.getActionItem({
            id: "dropdown-clickable-export-excel",
            icon: "download",
            messageId: "ui-inventory.excel.export",
            onClickHandler: buildOnClickHandler(() =>
              this.setState({ isColumnModalOpen: true })
            ),
            isDisabled: isInstancesListEmpty,
          })}
          {/* {canUseSingleRecordImport &&
            this.getActionItem({
              id: "dropdown-clickable-import-record",
              icon: "lightning",
              messageId: "ui-inventory.copycat.import",
              onClickHandler: buildOnClickHandler(() =>
                this.setState({ isImportRecordModalOpened: true })
              ),
            })} */}
          {/* kware start edit - Add bulk safe delete action for multiple selected instances */}
          {/* {canSafeDeleteMultiple &&
            selectedRowsCount > 0 &&
            this.getActionItem({
              id: "dropdown-clickable-safe-delete-multiple",
              icon: "trash",
              messageId: "ui-inventory.safeDeleteMultipleInstances",
              onClickHandler: buildOnClickHandler(
                this.handleSafeDeleteMultiple,
              ),
              isDisabled: !selectedRowsCount,
            })} */}
          {/* kware end edit */}
          {this.getActionItem({
            id: "dropdown-clickable-show-selected-records",
            icon: "eye-open",
            messageId: "ui-inventory.instances.showSelectedRecords",
            onClickHandler: buildOnClickHandler(() =>
              this.setState({ isSelectedRecordsModalOpened: true }),
            ),
            isDisabled: !selectedRowsCount,
          })}
        </MenuSection>
        <MenuSection
          label={intl.formatMessage({ id: "ui-inventory.bulkOperations" })}
          id="bulk-actions-menu-section"
        >
          {/* kware start edit - Add bulk edit action for instances (selected or all results) */}
          {this.getActionItem({
            id: "dropdown-clickable-bulk-edit-instances",
            icon: "edit",
            messageId:
              selectedRowsCount > 0
                ? "ui-inventory.bulkEditInstances"
                : "ui-inventory.bulkEditAllResults",
            onClickHandler: buildOnClickHandler(this.handleBulkEditInstances),
            isDisabled: isInstancesListEmpty,
          })}
          {/* kware end edit */}
        </MenuSection>
        <MenuSection
          data-testid="menu-section-sort-by"
          label={intl.formatMessage({
            id: "ui-inventory.actions.menuSection.sortBy",
          })}
        >
          <Select
            data-testid="sort-by-selection"
            dataOptions={sortOptions}
            value={getSortByValue()}
            onChange={setSortedColumn}
          />
        </MenuSection>
        <MenuSection
          label={intl.formatMessage({ id: "ui-inventory.showColumns" })}
          id="columns-menu-section"
        >
          {TOGGLEABLE_COLUMNS.map((key) => (
            <Checkbox
              key={key}
              name={key}
              data-testid={key}
              label={columnMapping[key]}
              id={`inventory-search-column-checkbox-${key}`}
              checked={visibleColumns.includes(key)}
              value={key}
              onChange={this.handleToggleColumn}
            />
          ))}
        </MenuSection>
      </>
    );
  };

  getRowURL = (id) => {
    const {
      match: { path },
      location: { search },
    } = this.props;

    return `${path}/view/${id}${search}`;
  };

  getIsAllRowsSelected = () => {
    const { parentResources } = this.props;
    const { selectedRows } = this.state;

    return parentResources.records.records.every(({ id }) =>
      Object.keys(selectedRows).includes(id),
    );
  };

  toggleAllRows = () => {
    const { parentResources } = this.props;
    const { selectedRows } = this.state;

    const toggledRows = parentResources.records.records.reduce(
      (acc, row) => ({
        ...acc,
        [row.id]: row,
      }),
      {},
    );

    const filterSelectedRows = (rows) => {
      Object.keys(toggledRows).forEach((id) => {
        if (rows[id]) delete rows[id];
      });
      return rows;
    };

    this.setState({
      selectedRows: this.getIsAllRowsSelected()
        ? filterSelectedRows(selectedRows)
        : { ...selectedRows, ...toggledRows },
    });
  };

  getColumnMapping = () => {
    const { intl } = this.props;

    const columnMapping = {
      callNumber: intl.formatMessage({
        id: "ui-inventory.instances.columns.callNumber",
      }),
      select: !this.state.isSelectedRecordsModalOpened && (
        <Checkbox
          checked={this.getIsAllRowsSelected()}
          aria-label={intl.formatMessage({
            id: "ui-inventory.instances.rows.select",
          })}
          onChange={() => this.toggleAllRows()}
        />
      ),
      title: intl.formatMessage({ id: "ui-inventory.instances.columns.title" }),
      contributors: intl.formatMessage({
        id: "ui-inventory.instances.columns.contributors",
      }),
      publishers: intl.formatMessage({
        id: "ui-inventory.instances.columns.publishers",
      }),
      relation: intl.formatMessage({
        id: "ui-inventory.instances.columns.relation",
      }),
      numberOfTitles: intl.formatMessage({
        id: "ui-inventory.instances.columns.numberOfTitles",
      }),
      subject: intl.formatMessage({ id: "ui-inventory.subject" }),
      contributor: intl.formatMessage({
        id: "ui-inventory.instances.columns.contributor",
      }),
      contributorType: intl.formatMessage({
        id: "ui-inventory.instances.columns.contributorType",
      }),
      relatorTerm: intl.formatMessage({
        id: "ui-inventory.instances.columns.relatorTerm",
      }),
      // kware start edit -- Adding columnMapping for updatedDate to enable column header display
      updatedDate: intl.formatMessage({
        id: "ui-inventory.instances.columns.updatedDate",
      }),
      // kware end edit
      "publication date": intl.formatMessage({
        id: "ui-inventory.instances.columns.publicationDate",
      }),
      classification: intl.formatMessage({
        id: "ui-inventory.instances.columns.classification",
      }),
      hrid: intl.formatMessage({ id: "ui-inventory.instances.columns.hrid" }),
      instanceType: intl.formatMessage({ id: "ui-inventory.instances.columns.instanceType" }),
      languages: intl.formatMessage({ id: "ui-inventory.instances.columns.languages" }),
      subjects: intl.formatMessage({ id: "ui-inventory.instances.columns.subjects" }),
      series: intl.formatMessage({ id: "ui-inventory.instances.columns.series" }),
      editions: intl.formatMessage({ id: "ui-inventory.instances.columns.editions" }),
      identifiers: intl.formatMessage({ id: "ui-inventory.instances.columns.identifiers" }),
      instanceStatus: intl.formatMessage({ id: "ui-inventory.instances.columns.instanceStatus" }),
      source: intl.formatMessage({ id: "ui-inventory.instances.columns.source" }),
      catalogedDate: intl.formatMessage({ id: "ui-inventory.instances.columns.catalogedDate" }),
      modeOfIssuance: intl.formatMessage({ id: "ui-inventory.instances.columns.modeOfIssuance" }),
      physicalDescriptions: intl.formatMessage({ id: "ui-inventory.instances.columns.physicalDescriptions" }),
      notes: intl.formatMessage({ id: "ui-inventory.instances.columns.notes" }),
      alternativeTitles: intl.formatMessage({ id: "ui-inventory.instances.columns.alternativeTitles" }),
      indexTitle: intl.formatMessage({ id: "ui-inventory.instances.columns.indexTitle" }),
      natureOfContent: intl.formatMessage({ id: "ui-inventory.instances.columns.natureOfContent" }),
      statisticalCodes: intl.formatMessage({ id: "ui-inventory.instances.columns.statisticalCodes" }),
      createdDate: intl.formatMessage({ id: "ui-inventory.instances.columns.createdDate" }),
    };

    return columnMapping;
  };

  onErrorModalClose = () => {
    this.setState({ showErrorModal: false });
  };

  toggleRowSelection = (row) => {
    this.setState(({ selectedRows }) => ({
      selectedRows: getNextSelectedRowsState(selectedRows, row),
    }));
  };

  handleResetAll = () => {
    this.setState({
      selectedRows: {},
    });

    facetsStore.getState().resetFacetSettings();
    this.inputRef.current.focus();
    sessionStorage.setItem(USER_TOUCHED_STAFF_SUPPRESS_STORAGE_KEY, false);
  };

  handleSelectedRecordsModalSave = (selectedRecords) => {
    this.setState({
      isSelectedRecordsModalOpened: false,
      selectedRows: selectedRecords,
    });
  };

  handleSelectedRecordsModalCancel = () => {
    this.setState({ isSelectedRecordsModalOpened: false });
  };

  handleImportRecordModalSubmit = (args) => {
    this.setState({ isImportRecordModalOpened: false });
    this.props.mutator.query.update({
      _path: "/inventory/import",
      xidtype: args.externalIdentifierType,
      xid: args.externalIdentifier,
      jobprofileid: args.selectedJobProfileId,
    });
  };

  handleImportRecordModalCancel = () => {
    this.setState({ isImportRecordModalOpened: false });
  };

  renderPaneSub() {
    const selectedRowsCount = size(this.state.selectedRows);

    return selectedRowsCount ? (
      <FormattedMessage
        id="ui-inventory.instances.rows.recordsSelected"
        values={{ count: selectedRowsCount }}
      />
    ) : null;
  }

  formatCellStyles(defaultCellStyle) {
    return `${defaultCellStyle} ${css.cellAlign}`;
  }

  formatSearchableIndex = (index) => {
    const { intl } = this.props;

    const { prefix = "" } = index;
    let label = index.label;
    if (index.label.includes("ui-inventory")) {
      label = prefix + intl.formatMessage({ id: index.label });
    }

    return { ...index, label };
  };

  findAndOpenItem = async (instance) => {
    const {
      parentResources,
      parentMutator: { itemsByQuery },
      getParams,
      stripes,
      history,
    } = this.props;
    const { query, qindex } = parentResources?.query ?? {};
    const { searchInProgress } = this.state;

    if (!searchInProgress) {
      return instance;
    }

    const itemQuery = buildSingleItemQuery(qindex, query);

    if (!itemQuery) {
      this.setState({ searchInProgress: false });
    }

    const tenantItemBelongsTo =
      instance?.items?.[0]?.tenantId || stripes.okapi.tenant;

    itemsByQuery.reset();
    const items = await itemsByQuery.GET({
      params: { query: itemQuery },
      headers: {
        [OKAPI_TENANT_HEADER]: tenantItemBelongsTo,
        [CONTENT_TYPE_HEADER]: "application/json",
        ...(stripes.okapi.token && {
          [OKAPI_TOKEN_HEADER]: stripes.okapi.token,
        }),
      },
    });

    this.setState({ searchInProgress: false });

    // if no results have been found or more than one item has been found
    // do not open item view
    if (items?.length > 1 || !items?.[0]?.holdingsRecordId) {
      return instance;
    }

    const { id, holdingsRecordId } = items[0];
    const search = stringify(getParams());

    const navigateToItemView = () => {
      history.push({
        pathname: `/inventory/view/${instance.id}/${holdingsRecordId}/${id}`,
        search,
        state: {
          tenantTo: tenantItemBelongsTo,
          tenantFrom: stripes.okapi.tenant,
        },
      });
    };

    await switchAffiliation(stripes, tenantItemBelongsTo, navigateToItemView);

    return null;
  };

  onSelectRow = (_, instance) => {
    const { parentResources } = this.props;
    const { query } = parentResources?.query ?? {};

    if (!query) {
      this.setState({ searchInProgress: false });
      return instance;
    }

    return this.findAndOpenItem(instance);
  };

  render() {
    const {
      canUseSingleRecordImport,
      disableRecordCreation,
      intl,
      data,
      parentResources,
      parentMutator,
      renderFilters,
      searchableIndexes,
      match: { path },
      namespace,
      stripes,
      segment,
    } = this.props;
    const {
      isSelectedRecordsModalOpened,
      isImportRecordModalOpened,
      selectedRows,
      searchAndSortKey,
      isSingleResult,
    } = this.state;

    const itemToView = getItem(`${namespace}.position`);

    const resultsFormatter = {
      select: ({ id, ...rowData }) => (
        <CheckboxColumn>
          <Checkbox
            checked={Boolean(selectedRows[id])}
            aria-label={intl.formatMessage({
              id: "ui-inventory.instances.rows.select",
            })}
            onChange={() =>
              this.toggleRowSelection({
                id,
                ...rowData,
              })
            }
          />
        </CheckboxColumn>
      ),
      /** kware start edit */
      updatedDate: ({ metadata }) => (
        metadata?.updatedDate ? <FormattedDate value={metadata.updatedDate} /> : ''
      ),
      /** kware end edit */
      title: ({
        title,
        discoverySuppress,
        isBoundWith,
        shared,
        staffSuppress,
        id,
      }) => {
        return (
          <div className={css.titleContainer}>
            <AppIcon
              size="small"
              app="inventory"
              iconKey="instance"
              iconAlignment="baseline"
            >
              <TextLink to={this.getRowURL(id)}>{title}</TextLink>
              {isBoundWith && (
                <AppIcon
                  size="small"
                  app="@folio/inventory"
                  iconKey="bound-with"
                  iconClassName={css.boundWithIcon}
                />
              )}
              {(discoverySuppress || staffSuppress) && (
                <span className={css.warnIcon}>
                  <Icon size="medium" icon="exclamation-circle" status="warn" />
                </span>
              )}
            </AppIcon>
            {shared && (
              <Icon
                size="medium"
                icon="graph"
                iconRootClass={css.sharedIconRoot}
                iconClassName={classnames(css.sharedIcon, {
                  [css.sharedIconLight]:
                    getItem(`${namespace}.${segment}.lastOpenRecord`) === id,
                })}
              />
            )}
          </div>
        );
      },
      relation: (r) =>
        formatters.relationsFormatter(r, data.instanceRelationshipTypes),
      // publishers: (r) =>
      //   (r?.publication ?? [])
      //     .map((p) =>
      //       (p
      //         ? `${p.publisher} ${
      //             p.dateOfPublication ? `(${p.dateOfPublication})` : ""
      //           }`
      //         : "")
      //     )
      //     .join(", "),
      /** kware start edit */
      publishers: (r) =>
        (r?.publication ?? [])
          .map((p) =>
            p
              ? `${p.publisher ? p.publisher : ""} ${
                  p.dateOfPublication ? `(${p.dateOfPublication})` : ""
                }`
              : "",
          )
          .join(", "),
      /** kware end edit */
      "publication date": (r) =>
        (r.publication || []).map((p) => p.dateOfPublication).join(", "),
      contributors: (r) =>
        formatters.contributorsFormatter(r, data.contributorTypes),
      classification: (r) =>
        (r?.classifications ?? [])
          .map((c) => c.classificationNumber)
          .filter(Boolean)
          .join(", "),
      hrid: (r) => r.hrid || '',
      instanceType: (r) => {
        const type = data.instanceTypes?.find(t => t.id === r.instanceTypeId);
        return type?.name || '';
      },
      languages: (r) => (r.languages || []).join(', '),
      subjects: (r) => (r.subjects || []).map(s => typeof s === 'string' ? s : s.value).filter(Boolean).join(', '),
      series: (r) => (r.series || []).map(s => s.value).filter(Boolean).join(', '),
      editions: (r) => (r.editions || []).join(', '),
      identifiers: (r) => (r.identifiers || []).map(i => `${i.value}`).filter(Boolean).join(', '),
      instanceStatus: (r) => {
        const status = data.instanceStatuses?.find(s => s.id === r.statusId);
        return status?.name || '';
      },
      source: (r) => r.source || '',
      catalogedDate: (r) => r.catalogedDate ? new Date(r.catalogedDate).toLocaleDateString() : '',
      modeOfIssuance: (r) => {
        const mode = data.modesOfIssuance?.find(m => m.id === r.modeOfIssuanceId);
        return mode?.name || '';
      },
      physicalDescriptions: (r) => (r.physicalDescriptions || []).join(', '),
      notes: (r) => (r.notes || []).map(n => n.note).filter(Boolean).join('; '),
      alternativeTitles: (r) => (r.alternativeTitles || []).map(t => t.alternativeTitle).filter(Boolean).join(', '),
      indexTitle: (r) => r.indexTitle || '',
      natureOfContent: (r) => (r.natureOfContentTermIds || []).map(id => {
        const term = data.natureOfContentTerms?.find(t => t.id === id);
        return term?.name || '';
      }).filter(Boolean).join(', '),
      statisticalCodes: (r) => (r.statisticalCodeIds || []).map(id => {
        const code = data.statisticalCodes?.find(c => c.id === id);
        return code?.code || '';
      }).filter(Boolean).join(', '),
      createdDate: (r) => r.metadata?.createdDate ? new Date(r.metadata.createdDate).toLocaleDateString() : '',
    };

    const visibleColumns = this.getVisibleColumns();
    const columnMapping = this.getColumnMapping();

    const onChangeIndex = () => {
      this.setState({ isSingleResult: true });
    };

    const formattedSearchableIndexes = searchableIndexes.map(
      this.formatSearchableIndex,
    );

    const advancedSearchOptions = advancedSearchIndexes[segment].map(
      this.formatSearchableIndex,
    );

    const advancedSearchQueryBuilder = (rows) => {
      const formatRowCondition = (row) => {
        // use default row formatter, but wrap each search term with parentheses

        const query = `${row.searchOption} ${row.match} ${row.query}`;
        return query;
      };

      return rows.reduce((formattedQuery, row, index) => {
        const rowCondition = formatRowCondition(row);

        if (index === 0) {
          return rowCondition;
        }

        return `${formattedQuery} ${row.bool} ${rowCondition}`;
      }, "");
    };

    const shortcuts = [
      {
        name: "new",
        handler: handleKeyCommand(() => {
          if (stripes.hasPerm("ui-inventory.instance.create")) {
            this.openCreateInstance();
          }
        }),
      },
    ];

    const checkScope = () => {
      const ignoreElements = ["TEXTAREA", "INPUT"];

      return !ignoreElements.includes(document.activeElement.tagName);
    };

    return (
      <HasCommand
        commands={shortcuts}
        isWithinScope={checkScope}
        scope={document.body}
      >
        <TitleManager page={this.getPageTitle()} />
        <div data-test-inventory-instances className={css.inventoryInstances}>
          <SearchAndSort
            key={searchAndSortKey}
            /** kware start editing */
            title={<FormattedMessage id="ui-inventory.meta.title" />}
            /** kware end editing */
            actionMenu={this.getActionMenu}
            packageInfo={packageInfo}
            objectName="inventory"
            maxSortKeys={1}
            renderNavigation={this.renderNavigation}
            searchableIndexes={formattedSearchableIndexes}
            advancedSearchIndex={queryIndexes.ADVANCED_SEARCH}
            advancedSearchOptions={advancedSearchOptions}
            advancedSearchQueryBuilder={advancedSearchQueryBuilder}
            selectedIndex={get(data.query, "qindex")}
            searchableIndexesPlaceholder={null}
            initialResultCount={INITIAL_RESULT_COUNT}
            initiallySelectedRecord={getItem(
              `${namespace}.${segment}.lastOpenRecord`,
            )}
            inputType="textarea"
            inputRef={this.inputRef}
            indexRef={this.indexRef}
            resultCountIncrement={RESULT_COUNT_INCREMENT}
            viewRecordComponent={ViewInstanceWrapper}
            editRecordComponent={InstanceForm}
            onChangeIndex={onChangeIndex}
            onSelectRow={this.onSelectRow}
            paneTitleRef={this.paneTitleRef}
            newRecordInitialValues={
              this.state && this.state.copiedInstance
                ? this.state.copiedInstance
                : {
                    discoverySuppress: false,
                    staffSuppress: false,
                    previouslyHeld: false,
                    source: "FOLIO",
                  }
            }
            visibleColumns={visibleColumns}
            nonInteractiveHeaders={["select"]}
            columnMapping={columnMapping}
            columnWidths={{
              callNumber: "15%",
              subject: "50%",
              contributor: "50%",
              contributors: {
                max: "400px",
              },
              numberOfTitles: "15%",
              select: "30px",
              title: "40%",
              contributorType: "15%",
              relatorTerm: "15%",
            }}
            getCellClass={this.formatCellStyles}
            customPaneSub={this.renderPaneSub()}
            resultsRowClickHandlers={false}
            resultsFormatter={resultsFormatter}
            resultRowFormatter={DefaultMCLRowFormatter}
            onCreate={this.onCreate}
            viewRecordPerms="ui-inventory.instance.view"
            newRecordPerms="ui-inventory.instance.create"
            disableRecordCreation={disableRecordCreation || false}
            parentResources={parentResources}
            parentMutator={parentMutator}
            detailProps={{
              referenceTables: data,
              onCopy: this.copyInstance,
            }}
            basePath={path}
            path={`${path}/(view|viewsource)/:id/:holdingsrecordid?/:itemid?`}
            showSingleResult={isSingleResult}
            renderFilters={renderFilters}
            onFilterChange={this.onFilterChangeHandler}
            onSubmitSearch={this.onSubmitSearch}
            pageAmount={100}
            pagingType={MCLPagingTypes.PREV_NEXT}
            extraParamsToReset={this.extraParamsToReset}
            hasNewButton={false}
            onResetAll={this.handleResetAll}
            // kware start edit -- Removing updatedDate from sortableColumns because backend doesn't support sorting by metadata.updatedDate
            sortableColumns={["title", "contributors", "updatedDate"]}
            // kware end edit
            syncQueryWithUrl
            resultsVirtualize={false}
            resultsOnMarkPosition={this.onMarkPosition}
            resultsOnResetMarkedPosition={this.resetMarkedPosition}
            resultsCachedPosition={itemToView}
          />
        </div>
        <ErrorModal
          isOpen={this.state.showErrorModal}
          label={
            <FormattedMessage id="ui-inventory.reports.inTransitItem.emptyReport.label" />
          }
          content={
            <FormattedMessage id="ui-inventory.reports.inTransitItem.emptyReport.message" />
          }
          onClose={this.onErrorModalClose}
        />
        <SelectedRecordsModal
          isOpen={isSelectedRecordsModalOpened}
          records={selectedRows}
          columnMapping={columnMapping}
          formatter={resultsFormatter}
          onSave={this.handleSelectedRecordsModalSave}
          onCancel={this.handleSelectedRecordsModalCancel}
        />
        <ColumnSelectionModal
          open={this.state.isColumnModalOpen}
          onClose={() => this.setState({ isColumnModalOpen: false })}
          onConfirm={(selectedColumns, reportName) => {
            this.setState({ isColumnModalOpen: false });
            this.handleExcelExport(selectedColumns, reportName);
          }}
          availableColumns={['title', ...TOGGLEABLE_COLUMNS]}
          columnMapping={columnMapping}
        />
        {/* {canUseSingleRecordImport && (
          <ImportRecordModal
            isOpen={isImportRecordModalOpened}
            currentExternalIdentifier={undefined}
            handleSubmit={this.handleImportRecordModalSubmit}
            handleCancel={this.handleImportRecordModalCancel}
          />
        )} */}
      </HasCommand>
    );
  }
}

export default withNamespace(
  flowRight(
    injectIntl,
    withLocation,
    withSingleRecordImport,
  )(stripesConnect(InstancesList)),
);
